import script from "./Activity_CheckLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_CheckLogin.vue?vue&type=script&setup=true&lang=js"

import "./Activity_CheckLogin.vue?vue&type=style&index=0&id=36b4fd3f&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b4fd3f"]])

export default __exports__